import {getTestProps} from '@benchling/js-test-utils';
import {css} from 'aphrodite';
import React from 'react';

import {ToolIconDisplay} from 'llm/chat-library/tool-details/ToolIconDisplay';
import {ToolIconSource} from 'llm/chat-library/tool-details/types';

import {agentProgressStyles} from './ChatProgress';

export interface ToolActivityItemProps {
  icon: ToolIconSource;
  displayName: string;
  onClick?: () => void;
  testComponent: string;
  testKey?: string;
}

/**
 * Shared tool activity item for displaying a tool call in progress.
 * Shows an icon and the tool's display name.
 */
export function ToolActivityItem({
  icon,
  displayName,
  onClick,
  testComponent,
  testKey,
}: ToolActivityItemProps): JSX.Element {
  return (
    <div
      {...getTestProps({component: testComponent, element: 'activityItem', key: testKey})}
      className={css(agentProgressStyles.activityItem, onClick && agentProgressStyles.activityItemClickable)}
      onClick={onClick}
    >
      <ToolIconDisplay
        icon={icon}
        glyphClassName={css(agentProgressStyles.activityIcon)}
        imgClassName={css(agentProgressStyles.activityIconImg)}
      />
      <div className={css(agentProgressStyles.activityDescription)}>
        <span
          className={css(agentProgressStyles.toolDescription)}
          {...getTestProps({
            component: testComponent,
            element: 'toolDescription',
            key: testKey,
          })}
        >
          {displayName}
        </span>
      </div>
    </div>
  );
}
